export class LineAndCandleData {
  yAxisLabel;
  xAxisLabel;
  data;

  constructor(xAxisLabel, yAxisLabel) {
    this.xAxisLabel = xAxisLabel;
    this.yAxisLabel = yAxisLabel;
    this.data = [];
  }

  addAvgMinMax(avgMinMax) {
    this.data.push(avgMinMax);
  }
}
